import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdminServiceGuard} from './admin-service.guard';
import {UserLocationsGuard} from './user-locations-service.guard';

const ROUTES: Routes = [
  {
    path: 'departures',
    loadChildren: () => import('./departures/departures.module').then(m => m.DeparturesModule)
  },
  {
    path: 'search',
    loadChildren: () => import('./search/search.module').then(m => m.SearchModule)
  },
  {
    path: '',
    redirectTo: '/departures',
    pathMatch: 'full'
  },
  {
    path: '',
    canActivate: [AdminServiceGuard],
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'locations',
    canActivate: [UserLocationsGuard],
    loadChildren: () => import('./user-locations/user-locations.module').then(m => m.UserLocationsModule)
  },
  {
    path: 'imports',
    canActivate: [AdminServiceGuard],
    loadChildren: () => import('./departures/import/import.module').then(m => m.ImportModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(ROUTES, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
      relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule]
})
export class DasRoutingModule {}
